var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4058 5.2578C20.5179 2.00347 17.0405 0 13.2786 0H9.70867L16.6358 12H13.0185C9.24971 12 5.76647 14.0104 3.88208 17.2751L0 24H3.61734C7.38613 24 10.8694 21.9896 12.7538 18.7249L13.6277 17.2116C14.5688 15.5803 15.7387 14.0948 17.0936 12.7931L20.5191 18.7249C22.4035 21.9884 25.8855 24 29.6555 24H33.2728L22.4058 5.2578Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.45ae5063012eff06515c72e64447a34c.svg";
export { ForwardRef as ReactComponent };